import {
  FETCH_BLOG_METRICS_REQUEST,
  FETCH_BLOG_METRICS_SUCCESS,
  FETCH_BLOG_METRICS_FAIL,
  CREATE_BLOG_METRIC_REQUEST,
  CREATE_BLOG_METRIC_SUCCESS,
  CREATE_BLOG_METRIC_FAIL,
  UPDATE_BLOG_METRIC_REQUEST,
  UPDATE_BLOG_METRIC_SUCCESS,
  UPDATE_BLOG_METRIC_FAIL,
  DELETE_BLOG_METRIC_REQUEST,
  DELETE_BLOG_METRIC_SUCCESS,
  DELETE_BLOG_METRIC_FAIL,
} from '../actions/blogMetricsActions';
const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
const loggedInUserId = loginData.hospitalID || null;

export default function blogMetricsReducer(state = { metrics: {}, loading: false, error: null }, action) {
  switch (action.type) {
    case FETCH_BLOG_METRICS_REQUEST:
    case CREATE_BLOG_METRIC_REQUEST:
    case UPDATE_BLOG_METRIC_REQUEST:
    case DELETE_BLOG_METRIC_REQUEST:
      return { ...state, loading: true };

      case FETCH_BLOG_METRICS_SUCCESS: {
        const raw = action.payload.data || [];
        const metricsMap = {};
      
        raw.forEach((item) => {
          if (!item.blogId) return;
      
          if (!metricsMap[item.blogId]) {
            metricsMap[item.blogId] = {
              totalViews: 0,
              uniqueViewersSet: new Set(),
              uniqueLikesSet: new Set(),
              uniqueDislikesSet: new Set(),
              currentUserMetric: null,
            };
          }
      
          const blogEntry = metricsMap[item.blogId];
          blogEntry.totalViews += Number(item.views || 0);
      
          if (item.userId != null) {
            blogEntry.uniqueViewersSet.add(item.userId);
            if (item.reaction === "like" || item.likes === "1") {
              blogEntry.uniqueLikesSet.add(item.userId);
            } else if (item.reaction === "dislike" || item.dislikes === "1") {
              blogEntry.uniqueDislikesSet.add(item.userId);
            }
          }
      
          if (String(item.userId) === String(loggedInUserId)) {
            blogEntry.currentUserMetric = item;
          }
        });
      
        for (const blogId in metricsMap) {
          metricsMap[blogId].uniqueViewersCount = metricsMap[blogId].uniqueViewersSet.size;
          metricsMap[blogId].uniqueLikesCount = metricsMap[blogId].uniqueLikesSet.size;
          metricsMap[blogId].uniqueDislikesCount = metricsMap[blogId].uniqueDislikesSet.size;
      
          // Remove Sets from final state to avoid serialization issues
          delete metricsMap[blogId].uniqueViewersSet;
          delete metricsMap[blogId].uniqueLikesSet;
          delete metricsMap[blogId].uniqueDislikesSet;
        }
      
        return {
          ...state,
          loading: false,
          error: null,
          metrics: metricsMap,
        };
      }
      

    case CREATE_BLOG_METRIC_SUCCESS:
    case UPDATE_BLOG_METRIC_SUCCESS:
      return { ...state, loading: false, error: null };

    case DELETE_BLOG_METRIC_SUCCESS:
      const newMetrics = { ...state.metrics };
      if (action.payload.blogId != null) {
        delete newMetrics[action.payload.blogId];
      }
      return { ...state, loading: false, metrics: newMetrics, error: null };

    case FETCH_BLOG_METRICS_FAIL:
    case CREATE_BLOG_METRIC_FAIL:
    case UPDATE_BLOG_METRIC_FAIL:
    case DELETE_BLOG_METRIC_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
}
